import { useQuery } from '@tanstack/react-query'
import { Navigate, Outlet, useLocation } from 'react-router'
import { sessionQuery } from '@/lib/api/queries'
import { currentAccount } from '@/lib/session'

/**
 * Locks the dashboard until the business profile is saved (W1-22).
 *
 * Sits inside `RequireSession`, so a session exists and the address is proven by
 * the time this renders. Guards the tenant dashboard only: the platform console
 * belongs to Ringout's own people (ADR-039), who have no business profile to fill.
 */
export function RequireOnboarded() {
  const location = useLocation()
  const session = useQuery(sessionQuery)
  const account = session.data ? currentAccount(session.data) : undefined

  if (!account?.onboarded) {
    const next = location.pathname + location.search
    return <Navigate to={`/onboarding?next=${encodeURIComponent(next)}`} replace />
  }
  return <Outlet />
}
